var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3H4.5C3.67158 3 3 3.67158 3 4.5V19.5C3 20.3284 3.67158 21 4.5 21H19.5C20.3284 21 21 20.3284 21 19.5V4.5C21 3.67158 20.3284 3 19.5 3Z",
    fill: "#1C1B1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 4.5C2.25 3.25736 3.25736 2.25 4.5 2.25H19.5C20.7427 2.25 21.75 3.25737 21.75 4.5V19.5C21.75 20.7427 20.7427 21.75 19.5 21.75H4.5C3.25737 21.75 2.25 20.7427 2.25 19.5V4.5ZM4.5 3.75C4.08579 3.75 3.75 4.08579 3.75 4.5V19.5C3.75 19.9142 4.08578 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V4.5C20.25 4.08578 19.9142 3.75 19.5 3.75H4.5Z",
    fill: "#1C1B1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2372 6.78851C10.6301 6.91949 10.8425 7.34423 10.7115 7.73719L7.71153 16.7372C7.58055 17.1301 7.15581 17.3425 6.76285 17.2115C6.36989 17.0805 6.15752 16.6558 6.28851 16.2628L9.28851 7.26285C9.41949 6.86989 9.84423 6.65752 10.2372 6.78851Z",
    fill: "#FFFBFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 11.75C16.4142 11.75 16.75 12.0858 16.75 12.5V16.5C16.75 16.9142 16.4142 17.25 16 17.25C15.5858 17.25 15.25 16.9142 15.25 16.5V12.5C15.25 12.0858 15.5858 11.75 16 11.75Z",
    fill: "#FFFBFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8.75C16.4142 8.75 16.75 9.08579 16.75 9.5V10C16.75 10.4142 16.4142 10.75 16 10.75C15.5858 10.75 15.25 10.4142 15.25 10V9.5C15.25 9.08579 15.5858 8.75 16 8.75Z",
    fill: "#FFFBFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.76285 6.78851C10.1558 6.65752 10.5805 6.86989 10.7115 7.26285L13.7115 16.2628C13.8425 16.6558 13.6301 17.0805 13.2372 17.2115C12.8442 17.3425 12.4195 17.1301 12.2885 16.7372L9.28851 7.73719C9.15752 7.34423 9.36989 6.91949 9.76285 6.78851Z",
    fill: "#FFFBFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 13.5C7.25 13.0858 7.58579 12.75 8 12.75H12C12.4142 12.75 12.75 13.0858 12.75 13.5C12.75 13.9142 12.4142 14.25 12 14.25H8C7.58579 14.25 7.25 13.9142 7.25 13.5Z",
    fill: "#FFFBFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrator);
export default __webpack_public_path__ + "static/media/Illustrator.6f7c106e.svg";
export { ForwardRef as ReactComponent };